// EN
import enAdministration from "@/locales/en/administration.json";
import enAlarms from "@/locales/en/alarms.json";
import enAuth from "@/locales/en/auth.json";
import enBilling from "@/locales/en/billing.json";
import enBillingOnboarding from "@/locales/en/billingOnboarding.json";
import enBillingPrediction from "@/locales/en/billingPrediction.json";
import enBudgetPlanning from "@/locales/en/budgetPlanning.json";
import enCommon from "@/locales/en/common.json";
import enComponents from "@/locales/en/components.json";
import enDashboard from "@/locales/en/dashboard.json";
import enDate from "@/locales/en/date.json";
import enDocuments from "@/locales/en/documents.json";
import enGeneration from "@/locales/en/generation.json";
import enGlossary from "@/locales/en/glossary.json";
import enLayout from "@/locales/en/layout.json";
import enMcpPrediction from "@/locales/en/mcpPrediction.json";
import enOsos from "@/locales/en/osos.json";
import enOsosOnboarding from "@/locales/en/ososOnboarding.json";
import enReports from "@/locales/en/reports.json";
import enSensors from "@/locales/en/sensors.json";
import enSustainability from "@/locales/en/sustainability.json";
import enTariffs from "@/locales/en/tariffs.json";
import enValidation from "@/locales/en/validation.json";
// TR
import trAdministration from "@/locales/tr/administration.json";
import trAlarms from "@/locales/tr/alarms.json";
import trAuth from "@/locales/tr/auth.json";
import trBilling from "@/locales/tr/billing.json";
import trBillingOnboarding from "@/locales/tr/billingOnboarding.json";
import trBillingPrediction from "@/locales/tr/billingPrediction.json";
import trBudgetPlanning from "@/locales/tr/budgetPlanning.json";
import trCommon from "@/locales/tr/common.json";
import trComponents from "@/locales/tr/components.json";
import trDashboard from "@/locales/tr/dashboard.json";
import trDate from "@/locales/tr/date.json";
import trDocuments from "@/locales/tr/documents.json";
import trGeneration from "@/locales/tr/generation.json";
import trGlossary from "@/locales/tr/glossary.json";
import trLayout from "@/locales/tr/layout.json";
import trMcpPrediction from "@/locales/tr/mcpPrediction.json";
import trOsos from "@/locales/tr/osos.json";
import trOsosOnboarding from "@/locales/tr/ososOnboarding.json";
import trReports from "@/locales/tr/reports.json";
import trSensors from "@/locales/tr/sensors.json";
import trSustainability from "@/locales/tr/sustainability.json";
import trTariffs from "@/locales/tr/tariffs.json";
import trValidation from "@/locales/tr/validation.json";

export const LANGUAGES = {
  TR: "tr",
  EN: "en",
} as const;

export const NAMESPACES = {
  COMMON: "common",
  ALARMS: "alarms",
  GLOSSARY: "glossary",
  VALIDATION: "validation",
  AUTH: "auth",
  DASHBOARD: "dashboard",
  OSOS: "osos",
  OSOS_ONBOARDING: "osos-onboarding",
  ADMINISTRATION: "administration",
  LAYOUT: "layout",
  TARIFFS: "tariffs",
  BILLING: "billing",
  BILLING_ONBOARDING: "billingOnboarding",
  COMPONENTS: "components",
  DOCUMENTS: "documents",
  DATE: "date",
  BUDGET_PLANNING: "budgetPlanning",
  SENSORS: "sensors",
  BILLING_PREDICTION: "billingPrediction",
  REPORTS: "reports",
  SUSTAINABILITY: "sustainability",
  MCP_PREDICTION: "mcpPrediction",
  GENERATION: "generation",
} as const;

export const DEFAULT_NAMESPACE = NAMESPACES.COMMON;

export const RESOURCES = {
  [LANGUAGES.TR]: {
    [NAMESPACES.AUTH]: trAuth,
    [NAMESPACES.COMMON]: trCommon,
    [NAMESPACES.DASHBOARD]: trDashboard,
    [NAMESPACES.GLOSSARY]: trGlossary,
    [NAMESPACES.VALIDATION]: trValidation,
    [NAMESPACES.OSOS]: trOsos,
    [NAMESPACES.OSOS_ONBOARDING]: trOsosOnboarding,
    [NAMESPACES.ADMINISTRATION]: trAdministration,
    [NAMESPACES.LAYOUT]: trLayout,
    [NAMESPACES.TARIFFS]: trTariffs,
    [NAMESPACES.BILLING]: trBilling,
    [NAMESPACES.BILLING_ONBOARDING]: trBillingOnboarding,
    [NAMESPACES.COMPONENTS]: trComponents,
    [NAMESPACES.DOCUMENTS]: trDocuments,
    [NAMESPACES.DATE]: trDate,
    [NAMESPACES.BUDGET_PLANNING]: trBudgetPlanning,
    [NAMESPACES.SENSORS]: trSensors,
    [NAMESPACES.BILLING_PREDICTION]: trBillingPrediction,
    [NAMESPACES.ALARMS]: trAlarms,
    [NAMESPACES.REPORTS]: trReports,
    [NAMESPACES.SUSTAINABILITY]: trSustainability,
    [NAMESPACES.MCP_PREDICTION]: trMcpPrediction,
    [NAMESPACES.GENERATION]: trGeneration,
  },
  [LANGUAGES.EN]: {
    [NAMESPACES.AUTH]: enAuth,
    [NAMESPACES.COMMON]: enCommon,
    [NAMESPACES.DASHBOARD]: enDashboard,
    [NAMESPACES.GLOSSARY]: enGlossary,
    [NAMESPACES.VALIDATION]: enValidation,
    [NAMESPACES.OSOS]: enOsos,
    [NAMESPACES.OSOS_ONBOARDING]: enOsosOnboarding,
    [NAMESPACES.ADMINISTRATION]: enAdministration,
    [NAMESPACES.LAYOUT]: enLayout,
    [NAMESPACES.TARIFFS]: enTariffs,
    [NAMESPACES.BILLING]: enBilling,
    [NAMESPACES.BILLING_ONBOARDING]: enBillingOnboarding,
    [NAMESPACES.COMPONENTS]: enComponents,
    [NAMESPACES.DOCUMENTS]: enDocuments,
    [NAMESPACES.DATE]: enDate,
    [NAMESPACES.BUDGET_PLANNING]: enBudgetPlanning,
    [NAMESPACES.SENSORS]: enSensors,
    [NAMESPACES.BILLING_PREDICTION]: enBillingPrediction,
    [NAMESPACES.ALARMS]: enAlarms,
    [NAMESPACES.REPORTS]: enReports,
    [NAMESPACES.SUSTAINABILITY]: enSustainability,
    [NAMESPACES.MCP_PREDICTION]: enMcpPrediction,
    [NAMESPACES.GENERATION]: enGeneration,
  },
} as const;
